import React, { useEffect } from "react";
import { scroller } from "react-scroll";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import CompanyOverview from "./components/CompanyOverview";
import Directors from "./components/Directors";
import Products from "./components/Products";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

const App = () => {
  useEffect(() => {
    scroller.scrollTo('herosection', {
      smooth: true,
      duration: 500
    });
  }, []);

  return (
    <>
      <Navbar />
      <HeroSection />
      <CompanyOverview />
      <Directors />
      <Products />
      <Contact />
      <Footer />
    </>
  );
};

export default App;